import { Injectable, inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { UserFrontendStateKey, UserGridColumnDto } from 'root/mibp-openapi-gen/models';
import { LogService } from 'root/services/logservice';
import { usersFnGetGridColumns } from "root/mibp-openapi-gen/fn/users/users-fn-get-grid-columns";
import { usersFnSaveGridColumns } from "root/mibp-openapi-gen/fn/users/users-fn-save-grid-columns";
import { MibpApiService } from "root/mibp-openapi-gen/mibp-api.service";

@Injectable({ providedIn: 'root' })
export class GridColumnService {
    private mibpApiService = inject(MibpApiService);
  private log = inject(LogService).withPrefix('grid-column-service');

  private gridColumnSelections: UserGridColumnDto[] = [];
  private loadPromise: Promise<void> | null = null;

  public loadColumnSelectionsForCurrentUser(): Promise<void> {
    if (!this.loadPromise) {
      this.loadPromise = this.fetchColumnSelections();
    }
    return this.loadPromise;
  }

  private async fetchColumnSelections(): Promise<void> {
    try {
      this.gridColumnSelections = await firstValueFrom(this.mibpApiService.invoke(usersFnGetGridColumns));
    } catch (error) {
      this.log.error('Failed to load grid column selections', error);
      this.gridColumnSelections = [];
      this.loadPromise = null;
    }
  }

  public getColumnSelection(key: UserFrontendStateKey): string[] | null {
    const match = this.gridColumnSelections.find(s => s.userFrontendStateKey === key);
    return match?.selectedColumns?.length ? match.selectedColumns : null;
  }

  public async saveColumnSelection(key: UserFrontendStateKey, columns: string[]): Promise<void> {
    try {
      await firstValueFrom(this.mibpApiService.invoke(usersFnSaveGridColumns, { body: { userFrontendStateKey: key, selectedColumns: columns } }));
    } catch (error) {
      this.log.error('Failed to save grid column selection', error);
      throw error;
    }

    const existing = this.gridColumnSelections.find(s => s.userFrontendStateKey === key);
    if (existing) {
      existing.selectedColumns = columns;
    } else {
      this.gridColumnSelections.push({ userFrontendStateKey: key, selectedColumns: columns });
    }

    this.loadPromise = null;
  }
}
